import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'

const day = dayjs

day.locale('zh-cn')

export default day

export function formatAsRelativeTime(date: string) {
	const now = dayjs()
	const past = dayjs(date)
	const delta = now.valueOf() - past.valueOf()

	const ONE_MINUTE = 60 * 1000
	const ONE_HOUR = 60 * ONE_MINUTE
	const ONE_DAY = 24 * ONE_HOUR
	const TEN_DAYS = 10 * ONE_DAY

	if (delta < ONE_MINUTE) {
		return '刚刚'
	} else if (delta < ONE_HOUR) {
		return `${Math.floor(delta / ONE_MINUTE)}分钟前`
	} else if (delta < ONE_DAY) {
		return `${Math.floor(delta / ONE_HOUR)}小时前`
	} else if (delta <= TEN_DAYS) {
		return `${Math.floor(delta / ONE_DAY)}天前`
	} else if (!now.isSame(past, 'year')) {
		return past.format('YYYY/MM/DD')
	} else if (!now.isSame(past, 'month') || !now.isSame(past, 'day')) {
		return past.format('MM/DD')
	} else {
		return past.format('HH:mm')
	}
}
